export const protocolTypes = [
    "smpp",
    "http/https",
    "smpp_mo"
];

export const isFilled = (v) => v !== undefined && v !== null && String(v).trim() !== "";

export const hasAnyOrganic = (v = {}) => {
    return isFilled(v.organic_ip) ||
        v.organic_port === 0 || isFilled(v.organic_port) ||
        isFilled(v.organic_login) ||
        isFilled(v.organic_password);
};

export const buildInitTrafficLimitList = ({ initialValues, isTransitTrunks, transitDefaultLimit }) => {
    const initTrafficValue = initialValues?.trafic_limit_list || [];
    const defaultDayValue = { day: transitDefaultLimit || 4 };
    const defaultHourValue = isTransitTrunks ? {} : { hour: 4 };

    const initTrafficLimitList = initialValues ? initialValues.id ? initTrafficValue : [{
        ...defaultDayValue,
        ...defaultHourValue,
        senderid: null,
        key: "new"
    }] : [];

    return {
        initTrafficLimitList,
        defaultDayValue,
        defaultHourValue,
    };
};
